import { Node, type NodeProps } from '@xyflow/react';
import { useIntl } from 'react-intl';
import { IconBolt } from '@rossum/ui/icons/tabler';
import { SvgIcon, useTheme } from '@rossum/ui/material';
import { BaseNode } from './BaseNode';
import { NODE_HEIGHT, type RuleNodeData } from './computeLayout';

export const RuleNode = ({ id, data }: NodeProps<Node<RuleNodeData>>) => {
  const theme = useTheme();
  const intl = useIntl();

  const tooltipTitle = data.enabled
    ? data.label
    : intl.formatMessage(
        {
          id: 'containers.settings.queues.queue.overview.disabledRuleTooltip',
        },
        { label: data.label }
      );

  return (
    <BaseNode
      id={id}
      label={data.label}
      accentColor={theme.palette.secondary.main}
      accentLightColor={theme.palette.secondary.light}
      icon={
        <SvgIcon fontSize="small" sx={{ color: theme.palette.text.secondary }}>
          <IconBolt />
        </SvgIcon>
      }
      dashed={!data.enabled}
      baseOpacity={data.enabled ? 1 : 0.6}
      minHeight={NODE_HEIGHT}
      tooltipTitle={tooltipTitle}
      tooltipEnterDelay={data.enabled ? 500 : 0}
      detailSections={[
        {
          label: intl.formatMessage({
            id: 'containers.settings.queues.queue.overview.node.dependencies',
          }),
          items: data.dependencies,
        },
      ]}
    />
  );
};
